import React from 'react';
import Option from './Option';

const OptionsList = ({ options, selectedValues, onToggleOption, showSearch }) => {
  return (
    <div className="" style={{ maxHeight: showSearch ? '250px' : '300px' }}>
      {options.map(option => (
        <Option
          key={option?.id || option?.value || `option-${Math.random()}`}
          option={option}
          isSelected={selectedValues.some(item => item?.value === option?.value)}
          onSelect={onToggleOption}
        />
      ))}
      {options.length === 0 && (
        <div className="px-4 py-3 text-sm text-gray-500 text-center">
          No results found
        </div>
      )}
    </div>
  );
};

export default OptionsList;